// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"dp-rfCDfERE","formContent":"dp-n0EWe1ns","desc":"dp-xuyhRfaz","btnsContainer":"dp-qDGIIvZx","bottomButton":"dp-crP5N8bI","bottomCancelButton":"dp-QPmmLCpq"};